import Logger from '../lib/logger';

export default class ProfessionalSystemCalculator {
	constructor(dom) {
		this.NAME = 'ProfessionalSystemCalculator';
		this.dom = dom;
		this.iframe = dom.querySelector(
			'[data-professional-system-calculator-iframe]'
		);
		this.expectedOrigin = dom.getAttribute('data-iframe-origin') || '';
		this.onMessageBound = this.onMessage.bind(this);
	}

	init() {
		Logger.info(`${this.NAME} > init`);

		if (!this.iframe || !this.expectedOrigin) return;

		window.removeEventListener('message', this.onMessageBound);
		window.addEventListener('message', this.onMessageBound);
	}

	onMessage(e) {
		if (e.origin !== this.expectedOrigin) return;
		if (!this.iframe || e.source !== this.iframe.contentWindow) return;

		const data = e.data;
		if (!data || data.type !== 'ssc-resize') return;
		if (typeof data.height !== 'number' || !isFinite(data.height)) return;

		this.iframe.style.height = `${data.height}px`;
	}
}
